export const LanguageData = [
  {
    value: 'en',
    label: 'Deutsch'
  },
  {
    value: 'de',
    label: 'English'
  }
]